export const PATH = {
    LOGIN: "/login",
    DASHBOARD: "/dashboard",
    PROFILE: "/profile",
    SUBMISSION: "/submission",
}